<app-navbar [title]="'Wydarzenie: ' + event?.name">
	<a routerLink="documents" class="btn btn-warning me-2" target="_blank"> Windykacja </a>
	<a routerLink="/tourism-events/{{ id }}" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Wydarzenie </a>
</app-navbar>

<app-event-business-payments
	[issue]="issueSelected"
	[paymentMethods]="parameters?.paymentMethods"
	[companiesAccounts]="accounts"
	[currencies]="currencies"
	(closed)="paymentsClose()"
></app-event-business-payments>

<table class="table table-striped table-hover">
	<thead class="table-dark">
		<tr>
			<th class="align-middle">Termin płatności</th>
			<th class="align-middle">Kwota</th>
			<th class="align-middle">Kwota w PLN</th>
			<th class="align-middle">Pozostało do zapłaty</th>
			<th class="align-middle">Waluta</th>
			<th class="align-middle">Sposób płatności</th>
			<th class="align-middle">Rodzaj dokumentu</th>
			<th class="align-middle">Numer dokumentu</th>
			<th class="align-middle">Sprzedawca</th>
			<th class="align-middle">Data wystawienia</th>
			<th class="align-middle"></th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let row of data">
			<td>
				<input type="date" class="form-control" name="due" [(ngModel)]="row.due" [disabled]="!row.editable" />
			</td>
			<td>
				<input
					type="number"
					step="0.01"
					class="form-control"
					name="value"
					(focusout)="changeValue(row.currency, row.id)"
					[(ngModel)]="row.value"
					[disabled]="!row.editable"
				/>
			</td>
			<td>
				<input type="number" class="form-control" name="valuePln" [(ngModel)]="row.valuePln" disabled="true" />
			</td>
			<td>
				<input
					type="number"
					step="0.01"
					class="form-control"
					name="settled"
					[(ngModel)]="row.settled"
					disabled="true"
				/>
			</td>
			<td>
				<select
					class="form-select"
					name="currency"
					[(ngModel)]="row.currency"
					[disabled]="!row.editable"
					(ngModelChange)="changeValue(row.currency, row.id)"
				>
					@for (item of currencies; track item.id) {
						<option [value]="item.id">
							{{ item.name }}
						</option>
					}
				</select>
			</td>
			<td>
				<select
					class="form-select"
					name="paymentMethod"
					[(ngModel)]="row.paymentMethod"
					[disabled]="!row.editable"
				>
					<option [value]="item.id" *ngFor="let item of parameters?.paymentMethods">
						{{ item.name }}
					</option>
				</select>
			</td>
			<td>
				<select
					class="form-select"
					name="documentType"
					[(ngModel)]="row.documentType"
					(change)="documentTypeChanged(row)"
					[disabled]="!row.editable"
				>
					<option [value]="item.id" *ngFor="let item of parameters?.documentTypes">
						{{ item.name }}
					</option>
				</select>
			</td>
			<td>
				<input
					type="text"
					class="form-control"
					name="documentNumber"
					[(ngModel)]="row.documentNumber"
					[disabled]="!row.editable"
				/>
			</td>
			<td>
				<select
					class="form-select"
					name="organization"
					[(ngModel)]="row.organization"
					[disabled]="!row.editable"
				>
					@for (item of organizations; track item.id) {
						<option [value]="item.id">
							{{ item.shortName }}
						</option>
					}
				</select>
			</td>
			<td>
				<input type="date" class="form-control" name="date" [(ngModel)]="row.date" [disabled]="!row.editable" />
			</td>
			<td class="text-end align-middle">
				<button class="btn btn-danger me-1" *ngIf="!row.editable" (click)="paymentsOpen(row)">Rozlicz</button>
				<button class="btn btn-primary" *ngIf="!row.editable" (click)="row.editable = true">Edytuj</button>
				<button class="btn btn-danger me-1" *ngIf="row.editable" (click)="save(row)">Zapisz</button>
				<button class="btn btn-primary" *ngIf="row.editable" (click)="deleteAskRow(row)">Usuń</button>
			</td>
		</tr>
	</tbody>
</table>
<div class="d-grid gap-2">
	<button class="btn btn-primary" (click)="addPos()"><i class="fas fa-plus"></i> Dodaj pozycję</button>
</div>
